module.exports = __webpack_public_path__ + "../resources/images/search-a33ef40d67aee8c6ad22787e063e731d.svg";